import { FC } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button } from '@microservices/wiskey-react-components'
import { Add } from '@mui/icons-material'
import { Grid } from '@mui/material'

import { getEmptyTab } from '@pages/WindowsCreateOrEdit/components/helpers/getDefaultValuesWindow'
import { Tab } from '@pages/WindowsCreateOrEdit/components/Tab/Tab'
import { FormSectionType } from '@pages/WindowsCreateOrEdit/types'

type TabsProps = {
  sectionIndex: number
}

export const Tabs: FC<TabsProps> = ({ sectionIndex }) => {
  const { t } = useTranslation()
  const { control, getValues, reset } = useFormContext<FormSectionType>()

  const {
    fields: tabs,
    append,
    update,
    remove,
  } = useFieldArray({
    control,
    name: `sections.${sectionIndex}.tabs` as const,
  })

  const handleAddTab = () => {
    const emptyValue = getEmptyTab()
    append(emptyValue)
  }

  const handleRemoveTab = (index: number) => {
    remove(index)
  }

  return (
    <>
      {tabs.map((field, index) => (
        <Tab
          key={field.id}
          removeTab={handleRemoveTab}
          sectionIndex={sectionIndex}
          tabIndex={index}
        />
      ))}
      <Grid container justifyContent={'flex-end'} pb={1} width={'100%'}>
        <Button onClick={handleAddTab}>
          <Add fontSize='small' />
          {t('window.buttons.addTab')}
        </Button>
      </Grid>
    </>
  )
}
